export const REDUCER_NAME = 'prospect'





// WEBPACK FOOTER //
// ./src/modules/prospect/state/const.js